module.exports = __webpack_public_path__ + "images/af70a847fb2c4dc63c28ef7a69c14a5042b270cc69a2cd7bfef02ea5d76a83b7.svg";